'use client';

import Image from 'next/image';
import classes from './FullScreenImageHalf.module.scss';
import { Box } from '@mantine/core';

type FullscreenImageProps = {
  src?: string;
  alt?: string;
  title: string;
  subtitle: string;
  absolute?: boolean;
  bgMask?: boolean;
};

const FullScreenImageHalf = ({ data }: { data: FullscreenImageProps }) => {
  const { src, alt, title, subtitle, absolute = true, bgMask } = data;

  const containerClass = [
    classes.box,
    absolute ? classes.absolute : classes.relative,
    bgMask ? classes.bgMask : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <>
      {absolute && <div className={classes.padding} />}
      <Box className={containerClass}>
        <Image
          src={src ?? ''}
          alt={alt ?? ''}
          fill
          className={classes.background}
          style={{ objectFit: 'fill' }}
        />
        <div className={classes.content}>
          <h1 className={classes.title}>{title}</h1>
          <h3 className={classes.subtitle}>{subtitle}</h3>
        </div>
      </Box>
    </>
  );
};

export default FullScreenImageHalf;
